<template>
  <div>
    <CCard>
      <CCardHeader>
        <CRow>
          <CCol class="align-self-center">
            <label class="mb-0 font-lg font-weight-bold">Topics</label>
          </CCol>
          <CCol class="text-right">
            <CButton @click="changeDefaultState" class="text-white mr-2" color="success" v-if="defaultState">
              <CIcon height="36" name="cil-library-add"/>
            </CButton>
            <CButton @click="changeDefaultState" class="text-white mr-2" color="danger" v-if="!defaultState">
              <CIcon height="36" name="cil-x"/>
            </CButton>
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody class="pt-0">
        <CCollapse :show="defaultState">
          <topics
              :fields="fields"
              :topics="topicLists"
              @deleteItem="confirmDeleteTopic"
              @editItem="editItem"
          />
        </CCollapse>
        <add-topic
            :editForm="editForm"
            @addTopicData="confirmAddTopicData"
            @cancel="changeDefaultState"
            v-if="!defaultState"
        />
      </CCardBody>
    </CCard>
    <CModal
        :centered="true"
        :show.sync="confirmModal"
        color="info"
        title="Confirm"
    >
      <span class="font-weight-bold font-lg mt-1">{{ courseName }}</span><br/>
      Topic name: {{ form.name }}
      <template #footer-wrapper>
        <CRow class="p-3">
          <CCol class="text-right">
            <CButton @click="confirmModal = false" class="mr-2" color="danger">Cancel</CButton>
            <CButton @click="confirmAddTopic" color="success">Confirm</CButton>
          </CCol>
        </CRow>
      </template>
    </CModal>
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import Topics from "@/components/topic/topics";
import AddTopic from "@/components/topic/addTopic";

export default {
  name: "MainTopic",
  components: {AddTopic, Topics},
  data() {
    return {
      defaultState: true,
      form: {},
      courseName: "",
      topicLists: [],
      tempId: "",
      confirmModal: false,
      fields: [
        {key: "no", label: "No.", _style: "width: 10%"},
        {key: "topic_name", label: "Topic name"},
        {key: "course_name", label: "Course name"},
        {key: "editOptions", label: "#"}
      ],
      editForm: {},
      editData: {}
    }
  },
  created() {
    this.$store.dispatch("topic/onSetTopics")
  },
  mounted() {
    this.$store.dispatch("topic/onSetTopics")
  },
  computed: {
    ...mapGetters({
      topics: "topic/getTopics",
      actionStatus: "action/actionStatus"
    })
  },
  watch: {
    actionStatus(value) {
      if (value) {
        this.deleteTopic()
      }
    },
    topics(value) {
      this.topicLists = []
      for (let i = 0; i < value.length; i++) {
        let body = {
          topic_name: value[i].name,
          course_name: value[i].course.name,
          topic_id: value[i]._id
        }
        this.topicLists.push(body)
      }
      this.defaultState = true
    }
  },
  methods: {
    changeDefaultState() {
      this.editForm = {}
      this.defaultState = !this.defaultState
    },
    confirmAddTopicData(value) {
      // course
      if (value.course) {
        this.courseName = value.course.course
        if (this.form.topicId !== "") delete this.form.topicId
        this.form.courseId = value.course.id
        this.form.name = value.name
      } else if (value.topic_id) {
        this.courseName = value.course_name
        if (this.form.courseId !== "") delete this.form.courseId
        this.form.topicId = value.topic_id
        this.form.name = value.name
      }
      this.confirmModal = true
    },
    confirmAddTopic() {
      this.confirmModal = false
      if (this.form.courseId) {
        this.$store.dispatch("topic/onCreateTopicName", this.form)
      } else if (this.form.topicId) {
        this.$store.dispatch("topic/onEditTopicName", this.form)
      }
    },
    confirmDeleteTopic(id) {
      this.tempId = id
      let body = {
        title: "Notification",
        color: "warning",
        status: true,
        text: "Do you really want to delete the topic?"
      }
      this.$store.commit("modal/onSetConfirmActionModalStatus", body)
    },
    deleteTopic() {
      this.$store.dispatch("topic/onDeleteTopic", this.tempId)
    },
    editItem(value) {
      this.defaultState = false
      this.editForm = value
    }
  }
}
</script>
